import { Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Checkbox, FormGroup,FormControl, Switch } from "@mui/material";
import { React,useEffect,useState } from "react";
import { Button } from "react-bootstrap";
import { endPoints } from "../../constant/Environment";
import { addData, getAllData, updateUser } from "../../Utility/API";
import Toaster from "../Toast";
import { ErrorToast, SuccesToast } from "../Toast/message";

const PaymentMethodModal = ({ open,setOpen, handlePaymentChange }) => {
  
  const handleCancel = () => setOpen(false);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    if (open) {
      fetchPaymentMethods();
    }
  }, [open]);

  const fetchPaymentMethods = async () => {
    setIsLoading(true);
    try {
      let url = `${endPoints.api.PAYMENT_METHOD}`;
      const response = await getAllData(url);
      setIsLoading(false);    
      if (response?.status === "success") {
        setPaymentMethods(response?.data);
      } else {
          ErrorToast(response?.message)
      }
    } catch (error) {
      setIsLoading(false);
      ErrorToast(error);
    }
  };

  const togglePaymentMethod = async (id, paymentMode, currentStatus) => {
    setIsLoading(true);
    try {
      let url = `${endPoints.api.UPDATE_PAYMENT}`;
      let updatedStatus = !currentStatus;
      const payload = {
        paymentMode,
        isActive: updatedStatus,
        id
      };
      const response = await addData(url, payload);
      if (response.data.status == "success") {
        setPaymentMethods((prevMethods) => {
          const updatedMethods = prevMethods.map((method) =>
            method?.id == id ? { ...method, isActive: updatedStatus } : method
          );
          return updatedMethods;
        });
        SuccesToast(response?.data?.message);
        setIsLoading(false);               
      } else {
        ErrorToast(response?.data?.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error updating payment method:");
      setIsLoading(false);
      ErrorToast(error);
    }
  };


  return (
    <>
    <Toaster></Toaster>
    <Dialog open={open} onClose={handleCancel}>
  <DialogTitle>Payment Method Options</DialogTitle>
  <DialogContent dividers>
    <FormControl component="fieldset" style={{ width: "100%"}}>
    <FormGroup column>
          {paymentMethods.map((method) => (
            <div key={method.id} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Switch
              checked={method.isActive}
              onChange={() => togglePaymentMethod(method.id, method.paymentMode, method.isActive)}
              color="primary"
            />
            <span>{method.paymentMode}{" "}{"Payment"}</span>
          </div>
          ))}
        </FormGroup>
    </FormControl>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCancel}>Close</Button>
  </DialogActions>
    </Dialog>
    </>
  );
};

export default PaymentMethodModal;
